import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3a5ad9d7&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=3a5ad9d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ad9d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5ad9d7')) {
      api.createRecord('3a5ad9d7', component.options)
    } else {
      api.reload('3a5ad9d7', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=3a5ad9d7&scoped=true", function () {
      api.rerender('3a5ad9d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/csg/detail.vue"
export default component.exports